import { useTranslation } from "react-i18next";
import { Pixels } from "@/assets/icons/Pixels.tsx";

export function EmptyPixels() {
  const { t } = useTranslation("pixels");

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
      <div className="w-[328px] items-center justify-center flex flex-col">
        <div className="mb-4">
          <Pixels></Pixels>
        </div>
        <h2 className="text-2xl font-semibold text-white mb-2">
          {t("empty.title")}
        </h2>
        <p className="text-zinc-400">{t("empty.description")}</p>
      </div>
    </div>
  );
}
